import { TMP_ELEMENT_POSITION, TMP_ELEMENT_SIZE } from '../shared/abstract-boxes';

export function ConditionsVariablesMultipleBoxViewConstructor(services, callbacks, context, siteTypeConfig) {

  let joint = services.joint;
  let companyId = context.companyId;
  let site = context.site;
  let scenarioId = context.scenarioId;

  return joint.shapes.html.AbstractBoxElementWithDragAndDropView.extend({
    numberOfValueChild: 0,
    isElementEditable: true,
    editElementModalController: 'editVariableController',
    editElementModalTemplate: require('./editVariable.modal.html'),


    angularTemplate: `
<div class="conditions-variable-multiple">
  <span ng-if="elementData.variable">
    {{ 'parameters/quick_replies/details/graph/conditions-variable-multiple/variable-equals' | translate:{variable: elementData.variable} }}
  </span>
  <span ng-if="!elementData.variable">
    {{ 'parameters/quick_replies/details/graph/conditions-variable-multiple/variable-equals-description' | translate }}
  </span>
  <div layout="column">
    <md-button ng-click="elementView.addValueChild()" ng-disabled="elementView.numberOfValueChild >= 10"> 
    {{ 'parameters/quick_replies/details/graph/conditions-variable-multiple/add-value-to-compare' | translate }}
    </md-button>
  </div>
</div>
`,
    initialize: function () {
      joint.shapes.html.AbstractBoxElementView.prototype.initialize.apply(this, arguments);
      setTimeout(() => this.updateValidity(), 500);
    },

    addValueChild: function () {
      services.QuickRepliesFactory.createUniqueId(companyId, site.id, scenarioId)
        .then(response => {
          let condition = this.createValueChild(response.data.id);
          this.model.graph.addCell(condition);
          this.model.embed(condition);
          this.numberOfValueChild++;
          this.updateValidity();
          this.reorderChildren();
          this.resizeBox();
        },
          services.AlertingFactory.httpErrorHandler());
    },

    createValueChild: function (id, position = TMP_ELEMENT_POSITION, size = TMP_ELEMENT_SIZE, elementData) {
      return new joint.shapes.html.NewValueChild({ id, position, size, elementData });
    },

    isChildAlwaysLast: function (child) {
      return child.get('type') === 'html.Else';
    },

    // useful for drag and drop, see AbstractBoxElementWithDragAndDropView.repositionOtherChildren
    paddingTop: function () {
      return this.heightOfHTMLContent();
    },

    afterEditElement: function () {
      this.updateValidity();
    },

    updateValidity: function () {
      if (!this.angularScope.elementData) {
        this.model.setBoxValid(false);
      } else {
        const valid = !!this.angularScope.elementData.variable;
        this.angularScope.elementData.references = {};

        this.angularScope.elementData.values = this.model.getEmbeddedCells()
          .filter((child) => child.get('type') !== 'html.Else')
          .map(child => {
            const value = child.get('elementData')?.value;
            if (value) {
              this.angularScope.elementData.references[value] = child.id;
            }
            return value;
          }) || [];
        const areChildrenValid = this.angularScope.elementData.values?.length && this.angularScope.elementData.values.every(value => !!value);
        this.model.setBoxValid(valid && areChildrenValid);

        // The watch mecanism to refresh the elementData model is not triggered when the change comes from the children.
        this.model.set('elementData', this.angularScope.elementData);
      }

    },
  });
}
